import styled from 'styled-components/';
import Calendar from 'react-calendar';
import AppCSS from '../../../utils/styled';
import { ProjectCalendarType } from './types';
import { DAY_TILE_HEIGHT_BIG, DAY_TILE_HEIGHT_SMALL, DAY_TILE_WIDTH_BIG, DAY_TILE_WIDTH_SMALL } from './constants';

export const Components = {
  CalendarWrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
  `,
  CustomHeader: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
  `,
  CustomHeaderTitle: styled.span`
    ${AppCSS.fonts.h5};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  CustomHeaderArrowWrapper: styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 8px;
  `,
  Calendar: styled(Calendar)<{ variant: ProjectCalendarType }>`
    border: none !important;

    & .react-calendar__navigation {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    & .react-calendar__navigation button {
      ${AppCSS.fonts.label14Bold};
      color: ${AppCSS.colors.black};
      text-transform: capitalize;
      padding: 9px 8px;
      background-color: transparent;
      border: none;

      &:hover {
        cursor: pointer;
      }
    }

    & .react-calendar__tile {
      ${AppCSS.fonts.label12Bold};
      color: ${AppCSS.colors.black};
      text-transform: capitalize;
      ${({ variant }) => (variant === 'modal' ? AppCSS.radiuses.small : AppCSS.radiuses.default)};

      &:hover {
        cursor: pointer;
      }
    }

    & .react-calendar__month-view__days abbr,
    .react-calendar__year-view__months abbr {
      ${({ variant }) => variant === 'dailyAlux' && 'display: none'};
    }

    & .react-calendar__month-view__weekdays {
      align-items: center;
      justify-content: space-between;
      ${AppCSS.fonts.label10Bold};
      color: ${AppCSS.colors.blues.veryDark};
      text-transform: capitalize;
      border-bottom: 1px solid ${AppCSS.colors.greys.light};
      padding: 8px ${({ variant }) => (variant === 'dailyAlux' ? 4 : 0)}px;
      margin-bottom: 8px;

      & abbr[title] {
        text-decoration: none !important;
      }
    }

    & .react-calendar__month-view__weekdays__weekday {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-basis: auto !important;
      width: 32px;
    }

    & .react-calendar__month-view__days {
      display: grid !important;
      grid-template-columns: repeat(7, 1fr);
      grid-gap: ${({ variant }) => (variant === 'modal' ? 16 : 4)}px;
    }

    & .react-calendar__month-view__days__day {
      width: ${({ variant }) => (variant === 'dailyAlux' ? DAY_TILE_WIDTH_BIG : DAY_TILE_WIDTH_SMALL)}px;
      max-width: ${({ variant }) => (variant === 'dailyAlux' ? DAY_TILE_WIDTH_BIG : DAY_TILE_WIDTH_SMALL)}px !important;
      height: ${({ variant }) => (variant === 'dailyAlux' ? DAY_TILE_HEIGHT_BIG : DAY_TILE_HEIGHT_SMALL)}px;
      border: none;
      background-color: transparent;

      &:hover,
      :focus {
        background: ${AppCSS.colors.blues.veryLight};
      }
    }

    & .react-calendar__tile--active,
    & .react-calendar__tile--hasActive {
      background-color: ${AppCSS.colors.blues.dark} !important;
      color: ${AppCSS.colors.white} !important;

      &:hover,
      :focus {
        background-color: ${AppCSS.colors.blues.dark} !important;
        color: ${AppCSS.colors.white} !important;
      }
    }

    & .react-calendar__month-view__days__day--neighboringMonth {
      color: ${AppCSS.colors.greys.medium};
    }

    & .react-calendar__year-view__months {
      display: grid !important;
      grid-template-columns: repeat(3, 1fr);
      column-width: 80px;
      grid-gap: 4px;

      & .react-calendar__year-view__months__month {
        padding: 12px;
        width: 100%;
        max-width: 100% !important;
        background-color: transparent;
        border: none;

        &:hover,
        :focus {
          background: ${AppCSS.colors.blues.veryLight};
          color: ${AppCSS.colors.blues.dark};
        }
      }
    }

    & .react-calendar__decade-view__years {
      display: grid !important;
      grid-template-columns: repeat(3, 1fr);
      column-width: 80px;
      grid-gap: 4px;

      & .react-calendar__decade-view__years__year {
        padding: 12px;
        width: 100%;
        max-width: 100% !important;
        background-color: transparent;
        border: none;

        &:hover {
          background: ${AppCSS.colors.blues.veryLight};
        }
      }
    }

    & .react-calendar__century-view__decades {
      display: grid !important;
      grid-template-columns: repeat(2, 1fr);
      column-width: 80px;
      grid-gap: 4px;

      & .react-calendar__century-view__decades__decade {
        padding: 12px;
        width: 100%;
        max-width: 100% !important;
        background-color: transparent;
        border: none;
        text-align: center;

        &:hover {
          background: ${AppCSS.colors.blues.veryLight};
        }
      }
    }
  `,
};
